import { environment } from '../../environments/environment';
import { ICompileProvider } from 'angular';

export function compileConfig( $compileProvider: ICompileProvider ) {
  if ( environment.production ) {
    $compileProvider.debugInfoEnabled(false);
  }
  $compileProvider.cssClassDirectivesEnabled(false);
  $compileProvider.commentDirectivesEnabled(false);
}

compileConfig.$inject = [ '$compileProvider' ];



// WEBPACK FOOTER //
// ./app/config/compile.config.ts